import { importDeferredViewObserver } from 'ca-dom-binding/importDeferredViewObserver';
import { DefoViews } from 'ca-dom-binding/types';
import { mountReactComponent } from 'ca-dom-binding/mountReactComponent';

/**
 * Common view observers
 *
 * These camel-cased keys are mapped to kebab-cased DOM nodes:
 *
 * fooBar -> data-${defoPrefix}-foo-bar="{props}"
 */
export const viewObservers: DefoViews = {
  logAmplitudeEvent: importDeferredViewObserver(
    () =>
      import(
        /* https://v4.webpack.js.org/guides/code-splitting/#dynamic-imports */
        /* webpackChunkName: "ca-dom-binding-logAmplitudeEvent" */
        './logAmplitudeEvent'
      )
  ),
  logAmplitudeEventWithGroups: importDeferredViewObserver(
    () =>
      import(
        /* https://v4.webpack.js.org/guides/code-splitting/#dynamic-imports */
        /* webpackChunkName: "ca-dom-binding-logAmplitudeEventWithGroups" */
        './logAmplitudeEventWithGroups'
      )
  ),
  reactComponent: mountReactComponent,
};
